<template>
    <div v-show="showComponents">
        <div class="ins-title">
            常用投保方案
            <div class="edit" @click="changeInsScheme">
                {{operator}}
            </div>
        </div>
        <div class="scheme-wrapper">
            <ul>
                <li v-for="(data,index) in schemes">
                    <div class="scheme" :class="{'selected':schemeIndex ===  index}" @click="useScheme(data,index)">
                        <div class="common">
                            <p class="money">{{parseInt(data.insuredAmount)/10000}}万</p>
                            <p class="type">{{data.goodsTypeValue}}</p>
                        </div>
                        <div class="departure">{{data.showDeparture}}</div>
                        <div class="destination">{{data.showDestination}}</div>
                        <div class="transit">{{data.showTransit}}</div>
                        <img src="../assets/delete.png" class="delete-btn" v-show="showDelete" @click.stop="deleteScheme(data.id,index)" alt="">
                    </div>
                </li>
            </ul>
        </div>
        <customer-dialog
                v-show="showDialog"
                @confirm="doDelete"
                @cancel="cancelDelete"
        >
            是否删除投保方案
        </customer-dialog>
    </div>
</template>

<script>
    import qs from 'qs'
    import {getGoodsType, getUserInfo, transAddress} from "../common/utils";
    import {showMsg} from "../common/utils";
    import CustomerDialog from './Dialog'
    import {mapState} from "vuex";

    const getSchemeUrl = "/hsbxjj-excellent-driving-insurance/scheme/getInsuranceSchemeList";
    const deleteSchemeUrl = "/hsbxjj-excellent-driving-insurance/scheme/deleteInsuranceSchemeById";
    export default {
        name: "InsScheme",
        components: {
            CustomerDialog
        },
        data(){
            return{
                showDelete:false,
                showComponents:false,
                schemes:[],
                //选中的scheme index
                schemeIndex:-1,
                operator:"编辑",
                //弹窗
                showDialog:false,
                //要删除的数据
                schemeId:"",
                index:-1,
            }
        },
        methods:{
            changeInsScheme(){
                this.showDelete = !this.showDelete;
                if (this.showDelete){
                    this.operator = "完成"
                }else {
                    this.operator = "编辑";
                }
            },
            doDelete(){
                this.showDialog = false;
                let schemeId = this.schemeId;
                let axiosInstance = this.$http.create({
                    headers:{
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                let data={schemeId};
                data = qs.stringify(data);
                axiosInstance.post(deleteSchemeUrl,data).then((res) => {
                    if (res.data.flag){
                        //成功
                        showMsg("删除成功！");
                        if (this.schemeIndex === this.index){
                            this.schemeIndex = -1;
                        } else if (this.schemeIndex > this.index){
                            this.schemeIndex  -= 1;
                        }
                        //删除一个元素
                        this.schemes.splice(this.index,1);
                        if (this.schemes.length === 0){
                            this.showComponents = false;
                        }
                    } else {
                        showMsg("删除失败，请稍后重试！")
                    }
                }).catch((err) => {
                    showMsg("删除失败，请稍后重试！")
                })
            },
            cancelDelete(){
                this.showDialog = false;
            },
            //删除常用方案
            deleteScheme(schemeId,index){
                this.showDialog = true;
                this.schemeId = schemeId;
                this.index = index;
            },
            //使用常用方案
            useScheme(data,index){
                if (this.schemeIndex === index){
                    this.schemeIndex = -1;
                } else {
                    this.schemeIndex = index;
                    let startPlace = data.carriagestartplacename.split('-');
                    let startPlaceCode = data.carriagestartplace.split('-');

                    let destination = data.destinationname.split('-');
                    let destinationCode = data.destination.split('-');

                    let transit = ['','',''];
                    let transitCode = ['','',''];
                    if (data.transferName){
                        //有中转地
                        transit = data.transferName.split('-');
                        transitCode = data.transfer.split('-');
                    }
                    let riskGroupInfo = {
                        cargoType: data.goodsType,
                        cargoName:data.goodsName,
                        carriageStartPlace:{
                            province:startPlace[0],
                            city: startPlace[1],
                            county: startPlace[2],
                            provinceCode: startPlaceCode[0],
                            cityCode: startPlaceCode[1],
                            countyCode: startPlaceCode[2]
                        },
                        transferPlace:{
                            province:transit[0],
                            city: transit[1],
                            county: transit[2],
                            provinceCode: transitCode[0],
                            cityCode: transitCode[1],
                            countyCode: transitCode[2]
                        },
                        destination:{
                            province:destination[0],
                            city: destination[1],
                            county: destination[2],
                            provinceCode: destinationCode[0],
                            cityCode: destinationCode[1],
                            countyCode: destinationCode[2]
                        }
                    };
                    //货物信息
                    this.$store.commit('certificate/setRiskGroupInfo',[riskGroupInfo]);

                    let insuredInfo = {
                        certificateType:data.insuredCertitype,
                        personnelType:data.insuredType,
                        name:data.insuredName,
                        certificateNo:data.insuredCertino
                    };

                    //是否同被保人
                    this.$store.commit('certificate/setSamePerson',data.isSamePerson);
                    //被保人信息
                    this.$store.commit('certificate/setInsuredInfoList',[insuredInfo]);
                    //车牌号
                    this.$store.commit('certificate/setVehicleNo',data.plateNumber);
                    //保额
                    this.$store.commit('certificate/setAmount',data.insuredAmount);
                    this.$emit('useScheme');
                }
            }
        },
        mounted() {
            let axiosInstance = this.$http.create({
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            let ownerId = getUserInfo().mobile;
            if (ownerId){
                let data = {ownerId};
                data = qs.stringify(data);
                axiosInstance.post(getSchemeUrl,data).then((res) => {
                    if (res.data.flag){
                        this.schemes = res.data.data;
                        for (let i=0;i<this.schemes.length; i++){
                            this.schemes[i].goodsTypeValue = getGoodsType(this.schemes[i].goodsType);
                            this.schemes[i].showDeparture = transAddress(this.schemes[i].carriagestartplacename);
                            this.schemes[i].showDestination = transAddress(this.schemes[i].destinationname);
                            this.schemes[i].showTransit = transAddress(this.schemes[i].transferName);
                        }
                        if (this.schemes.length > 0){
                            this.showComponents = true
                        }
                    }
                })
            }

        }
    }
</script>

<style scoped lang="scss">
    .ins-title{
        height: 12vw;
        padding-left: 13.33vw;
        margin-top: 2.67vw;
        line-height: 12vw;
        font-size: 4.27vw;
        font-weight: bold;
        text-align: left;
        background: url(../assets/collect.png) no-repeat 5.33vw center #ffffff;
        background-size: 5.33vw;
        .edit{
            float: right;
            padding-right: 5.33vw;
            font-size: 4vw;
            font-weight: normal;
            color: #3385ff;
        }
        &:after{
            clear: both;
        }
    }
    .base-address{
        padding-left: 4.67vw;
        line-height: 4.67vw;
        font-size: 2.93vw;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .scheme-wrapper{
        /*height: 28.67vw;*/
        padding-left: 5.33vw;
        padding-bottom: 4vw;
        background: #ffffff;
        overflow-x: hidden;
        ul{
            /*height: 26.67vw;*/
            margin: 0;
            padding: 0;
            text-align: left;
            white-space: nowrap;
            overflow: auto;
            li{
                position: relative;
                display: inline-block;
                width: 38.67vw;
                margin-right: 1.33vw;
                padding-top: 2.13vw;
                vertical-align: middle;
                list-style: none;
                .scheme{
                    width: 33.67vw;
                    height: 18.67vw;
                    padding: 2.67vw 1.33vw 1.33vw;
                    border: .27vw solid #ddd;
                    border-radius: 1.33vw;
                    color: #000;
                    .common{
                        display: flex;
                        justify-content: space-between;
                        line-height: 6vw;
                        .money{
                            font-weight: bold;
                            text-align: left;
                        }
                        .type{
                            text-align: right;
                            font-size: 3.2vw;
                        }
                    }
                    .deductible{
                        position: absolute;
                        width: 9.2vw;
                        top: 1.34vw;
                        right: 1.34vw;
                    }
                    .departure{
                        background: url(../assets/depature_1.png) no-repeat 0 center;
                        background-size: 3.33vw;
                        @extend .base-address
                    }
                    .destination{
                        background: url(../assets/destination_1.png) no-repeat 0 center;
                        background-size: 3.33vw;
                        @extend .base-address
                    }
                    .transit{
                        background: url(../assets/transit_1.png) no-repeat 0 center;
                        background-size: 3.33vw;
                        @extend .base-address
                    }
                }
                .selected{
                    color: #ffffff;
                    background: #3385ff;
                    .departure{
                        background: url(../assets/depature_2.png) no-repeat 0 center;
                        background-size: 3.33vw;
                        @extend .base-address
                    }
                    .destination{
                        background: url(../assets/destination_2.png) no-repeat 0 center;
                        background-size: 3.33vw;
                        @extend .base-address
                    }
                    .transit{
                        background: url(../assets/transit_2.png) no-repeat 0 center;
                        background-size: 3.33vw;
                        @extend .base-address
                    }
                }
                .delete-btn{
                    position: absolute;
                    width: 4.27vw;
                    top: 0;
                    right: 0;
                    z-index: 99;
                }
            }
        }
        &:after{
            clear: both;
        }
    }
</style>